import axios from 'axios';
import { backendHOST } from '../client-config/client-config';

const headers = () => ({
  'x-auth-token': localStorage.token,
});

export async function getLoggedInUsers() {
  const response = await axios.get(`${backendHOST}/api/stats/LoggedInUsers`, {
    headers: headers(),
  });

  return response.data;
}

export async function getActualPriceList() {
  const response = await axios.get(
    `${backendHOST}/api/scriptantiaAdmin/ActualPriceList`,
    {
      headers: headers(),
    },
  );

  return response.data;
}

export async function getTodaysLessons() {
  const response = await axios.get(`${backendHOST}/api/stats/TodaysLessons`, {
    params: {
      sort: JSON.stringify({
        selector: 'date_start',
        desc: false,
      }),
    },
    headers: headers(),
  });

  return response.data;
}
